module.exports = __webpack_public_path__ + "static/media/amm_logo.109e3e7a.png";